import { Box, Container, Stack } from '@mui/material';
import { useNavigate } from 'react-router';
import logoSource from '../../assets/sustain_logo.png';
import { useTypedSelector } from '../../reducers';
import { useIsAuthenticated } from '../../hooks';
import VerificationForm from './VerificationForm';
import LoginForm from './LoginForm';
import React from 'react';

export default function LoginScreen() {
  const navigate = useNavigate();
  const [twoFactorRequired, setTwoFactorRequired] = React.useState(false);
  const [phoneDigits, setPhoneDigits] = React.useState('');
  const { viewMode } = useTypedSelector((state) => state.auth);

  const isAuthenticated = useIsAuthenticated();

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate(viewMode === 'admin' ? '/library' : '/users');
    }
  }, [isAuthenticated, navigate, viewMode]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <Container>
        <Stack alignItems="center" spacing={5}>
          <img src={logoSource} alt="logo" width={212} height={67} />
          <Box width="100%" maxWidth={552}>
            {twoFactorRequired ? (
              <VerificationForm phoneDigits={phoneDigits} />
            ) : (
              <LoginForm
                showTwoFactorForm={(phoneDigits) => {
                  setTwoFactorRequired(true);
                  setPhoneDigits(phoneDigits);
                }}
              />
            )}
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
